import { render, staticRenderFns } from "./FileDropZone.vue?vue&type=template&id=616db4f2"
import script from "./FileDropZone.vue?vue&type=script&lang=js"
export * from "./FileDropZone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('616db4f2')) {
      api.createRecord('616db4f2', component.options)
    } else {
      api.reload('616db4f2', component.options)
    }
    module.hot.accept("./FileDropZone.vue?vue&type=template&id=616db4f2", function () {
      api.rerender('616db4f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileDropZone.vue"
export default component.exports